import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { EquipmentType } from "../../types/types";

export const useEquipmentTypes = () => {
  const setEquipmentTypes = useAppStore((state) => state.setEquipmentTypes);

  const [{ response: equipmentTypesData }, doFetchEquipmentTypes] = useFetch("/directories/equipment_types");

  useEffect(() => {
    let equipmentTypes = equipmentTypesData?.data as unknown as EquipmentType[];
    if (equipmentTypes) setEquipmentTypes(equipmentTypes);
  }, [equipmentTypesData]);

  return doFetchEquipmentTypes;
};
